import _ from 'lodash';
import React from 'react';
import shallowCompare from '../../../lib/shallowCompare';
import styles from './index.sass';

class OrderNotes extends React.Component {
  static contextTypes = {
    executeAction : React.PropTypes.func
  };

  static propTypes = {
    error: React.PropTypes.object,
    requestStatus: React.PropTypes.string,
    handleOrderNotesChange: React.PropTypes.func
  };

  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  renderNotesInput() {
    let noteInputProps = {
      className   : styles.noteInput,
      placeholder : 'Notes',
      maxLength   : 200,
      value       : this.props.notes,
      onChange    : this.props.handleOrderNotesChange
    };
    return <textarea {...noteInputProps} />;
  }

  render() {
    return (
      <div className={styles.contactInfo}>
        {this.renderNotesInput()}
      </div>
    );
  }
}

export default OrderNotes;



// WEBPACK FOOTER //
// banquet/components/Checkout/OrderNotes/index.js